import { getActiveOrgSlug } from "@/lib/api";

/**
 * Headers for every Amanda request. The widget used a raw fetch with only
 * `Authorization`, so no `X-Active-Org` ever reached the chat API — for a
 * member of a Business/Enterprise workspace Amanda then resolved the HOME
 * (personal, free) org and told a paying workspace owner "you're on the free
 * plan" (seen on the Nichiha account, 2026-09-15, and in the Phase B
 * acceptance run). Same rule as `apiFetch`: the workspace in the URL wins.
 */
export function chatAuthHeaders(token: string, extra: Record<string, string> = {}): Record<string, string> {
  const headers: Record<string, string> = { Authorization: `Bearer ${token}`, ...extra };
  const slug = getActiveOrgSlug();
  if (slug) headers["X-Active-Org"] = slug;
  return headers;
}
